import { render } from "./SuppliersServices.vue?vue&type=template&id=0619a4a8&scoped=true"
import script from "./SuppliersServices.vue?vue&type=script&lang=js"
export * from "./SuppliersServices.vue?vue&type=script&lang=js"

import "./SuppliersServices.vue?vue&type=style&index=0&id=0619a4a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0619a4a8"]])

export default __exports__